app.factory('visitCardService', ['$q', '$http', 'baseService', 'objectHelper', 'config',
    function($q, $http, baseService, objectHelper, config) {

        function VisitCardService() {

            this.getById = function (id) {
                return baseService.get(config.API_URL + '/visitCards/' + id).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, VisitCardVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getP1ById = function (id) {
                return baseService.get(config.API_URL + '/prescriptions/' + id + '/p1').then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getEReferralById = function (id, fullVersion) {
                var  full = fullVersion ? '?full=true' : '';
                return baseService.get(config.API_URL + '/referrals/' + id + '/p1' + full).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteEReferral = function (id, password) {
                return baseService.post(config.API_URL + '/referrals/' + id + '/p1/cancel', {password: password}).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.save = function(idVisitCard) {
                return baseService.post(config.API_URL + '/visitCards', idVisitCard).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, VisitVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.update = function(visitCard) {
                return baseService.post(config.API_URL + '/visitCards/' + visitCard.id, visitCard).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, VisitCardVO);
                        //data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.startStreamRecording = function(id) {
                return baseService.post(config.API_URL + '/streaming/' + id + '/startRecording').then(
                    function(successResponse) {
                        return true;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.stopStreamRecording = function(id) {
                return baseService.post(config.API_URL + '/streaming/' + id + '/stopRecording').then(
                    function(successResponse) {
                        return true;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateTextFields = function(visitCardId, visitCardTextFieldsWrapper) {
                return baseService.post(config.API_URL + '/visitCards/' + visitCardId + '/updateTextFields', visitCardTextFieldsWrapper).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new VisitCardService();
    }
]);
